// ===================================================================
// 🔐 Analista — alterar senha (após login, via cabeçalho)
// ===================================================================

import React, { useState, useCallback } from 'react';
import { styles } from '../../styles/globalStyles';
import { Modal } from '../ui/Modal';
import { Alert } from '../ui/Alert';
import { apiClient } from '../../api/apiClient';
import { validateNewPassword, PASSWORD_POLICY_HINT } from '../../utils/passwordPolicy';

export const AnalystChangePasswordModal = React.memo(({ onClose, onUserUpdate }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    if (!currentPassword.trim()) {
      setError('Informe a senha atual');
      return;
    }
    const pwdErr = validateNewPassword(newPassword);
    if (pwdErr) {
      setError(pwdErr);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    setSaving(true);
    try {
      const updated = await apiClient.auth.changePassword({
        current_password: currentPassword,
        password: newPassword,
      });
      onUserUpdate?.(updated);
      onClose?.();
    } catch (err) {
      setError(err.message || 'Não foi possível alterar a senha');
    } finally {
      setSaving(false);
    }
  }, [currentPassword, newPassword, confirmPassword, onClose, onUserUpdate]);

  return (
    <Modal isOpen onClose={onClose} title="Alterar senha">
      <form onSubmit={handleSubmit} style={styles.form}>
        {error && <Alert type="error" message={error} onClose={() => setError('')} />}
        <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
          {PASSWORD_POLICY_HINT}
        </p>
        <div style={{ marginBottom: '16px' }}>
          <label style={styles.label}>Senha atual *</label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
            style={styles.input}
            required
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={styles.label}>Nova senha *</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
            style={styles.input}
            minLength={6}
            required
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={styles.label}>Confirmar nova senha *</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            style={styles.input}
            required
          />
        </div>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} style={{ ...styles.button, ...styles.buttonSecondary }}>
            Cancelar
          </button>
          <button type="submit" disabled={saving} style={{ ...styles.button, ...styles.buttonPrimary, opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Salvando...' : 'Salvar nova senha'}
          </button>
        </div>
      </form>
    </Modal>
  );
});
